export const MAX_FONT_SIZE = 60; //this is being scaled now. it's way to large even at 60.
export const MIN_FONT_SIZE = 10;
export const DEFAULT_FONT_SIZE = 26;

export const WEB_SAFE_FONTS = [
	{
		label: "Arial",
		value: "Arial, sans-serif",
	},
	{
		label: "Brush Script MT",
		value: "Brush Script MT, cursive",
	},
	{
		label: "Courier New",
		value: "Courier New, monospace",
	},
	{
		label: "Garamond",
		value: "Garamond, serif",
	},
	{
		label: "Georgia",
		value: "Georgia, serif",
	},
	{
		label: "Tahoma",
		value: "Tahoma, sans-serif",
	},
	{
		label: "Times New Roman",
		value: "Times New Roman, serif",
	},
	{
		label: "Trebuchet MS",
		value: "Trebuchet MS, sans-serif",
	},
	{
		label: "Verdana",
		value: "Verdana, sans-serif",
	},
];

export const TEXT_COLORS = {
	WHITE: "#FFFFFF",
	BLACK: "#000000",
};

export const BACKGROUND_GRADIENTS = {
	WHITE: "linear-gradient(to bottom, rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0.75))",
	BLACK: "linear-gradient(to bottom, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75))",
};

export const CUE_ALIGNMENT = {
	START: "start",
	CENTER: "center",
	END: "end",
};

export const CUE_MARGIN_PERCENTAGE = 5;
export const DEFAULT_CUE_LINE_PERCENTAGE = 90;
export const MIN_SUBTITLE_LINE_PERCENTAGE = 5;
export const MAX_SUBTITLE_LINE_PERCENTAGE = 95;
export const DEFAULT_CUE_ALIGN = CUE_ALIGNMENT.CENTER;
export const DEFAULT_CUE_BOX_SIZE = 98; // 98%
export const DEFAULT_CUE_POSITION = 0;

export const CUE_BOX_PLACEMENT = {
	"9/16": { size: 30, cueMargin: 50 },
	"16/9": { size: DEFAULT_CUE_BOX_SIZE, cueMargin: 0 },
	"1/1": { size: 52, cueMargin: 48 },
	"4/5": { size: 50, cueMargin: 50 },
};
